import type { ReactNode } from 'react'
import { Button } from './ui/button'
import { PageLayout } from './PageLayout'
import { EmptyState } from './EmptyState'
import { goHomeButtonLabel } from '@/lib/commonStrings'
import { useTransitionNavigate } from '@/lib/viewTransition'

export function NotFoundState({ message }: { message: ReactNode }) {
  const navigate = useTransitionNavigate()
  return (
    <PageLayout className="space-y-4">
      <EmptyState>{message}</EmptyState>
      <Button
        variant="ghost"
        size="sm"
        className="cursor-pointer"
        onClick={() => navigate('/', { replace: true, direction: 'back' })}
      >
        {goHomeButtonLabel()}
      </Button>
    </PageLayout>
  )
}
